const verificationTypes = {
	/*********** SEND AADHAR OTP START ****************** */
	SEND_AADHAR_OTP_START: 'send_aadhar_otp_start',
	SEND_AADHAR_OTP_SUCCESS: 'send_aadhar_otp_success',
	SEND_AADHAR_OTP_FAILURE: 'send_aadhar_otp_failure',
	SEND_AADHAR_OTP_RESPONSE_RESET_START: 'send_aadhar_otp_response_reset_start',
	SEND_AADHAR_OTP_RESPONSE_CHANGED: 'send_aadhar_otp_response_changed',
	/*********** SEND AADHAR OTP END ****************** */

	/*********** AADHAR OTP VERIFY START ****************** */
	AADHAR_OTP_VERIFY_START: 'aadhar_otp_verify_start',
	AADHAR_OTP_VERIFY_SUCCESS: 'aadhar_otp_verify_success',
	AADHAR_OTP_VERIFY_FAILURE: 'aadhar_otp_verify_failure',
	AADHAR_OTP_VERIFY_RESPONSE_RESET_START: 'aadhar_otp_verify_response_reset_start',
	AADHAR_OTP_VERIFY_RESPONSE_CHANGED: 'aadhar_otp_verify_response_changed',
	/*********** AADHAR OTP VERIFY END ****************** */
};
export default verificationTypes;
